import * as Yup from "yup";

export const addvalidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required!"),
});

export const editvalidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required!"),
});

export const addTalukavalidationSchema = Yup.object().shape({
  parent_id: Yup.number().required("District is required!"),
  name: Yup.string().required("Name is required!"),
  is_active: Yup.number().required("Status is required!"),
});

export const addVillagevalidationSchema = Yup.object().shape({
  parent_id: Yup.number().required("Taluka is required!"),
  name: Yup.string().required("Name is required!"),
  is_active: Yup.number().required("Status is required!"),
});
